import { FaCartPlus } from "react-icons/fa";
import { useCartContext } from "../../Context/CartContext.jsx";
import { useRef, useState } from "react";

const ProductsByCategory = ({ categoryName, products }) => {
  const [isBrokenImage, setIsBrokenImage] = useState([]);
  const fallbackImage = useRef("/images/ProductImages/placeholder650x650.jpg");

  const brokenImage = (productId) => isBrokenImage.includes(productId);

  const { addProduct } = useCartContext();

  const handleAdd = (product) => {
    addProduct(product);
  };

  return (
    <div className="products-bycategory-container py-2 pb-10 px-4 w-full flex flex-col relative border-solid border-b-[2px] border-mariposa">
      <h3 className="category-title"> {categoryName} </h3>
      <ul className="products-container px-5 flex gap-[40px] flex-wrap justify-center">
        {products.map((product) => (
          <li
            key={product.id}
            className="flex flex-col items-center lg:min-h-[400px]  min-w-[280px] max-w-[320px] flex-1 shadow-[0px_0px_7px_4px_rgba(0,0,0,0.1)] rounded-md max-h-[500px]"
          >
            <img
              src={
                brokenImage(product.id)
                  ? fallbackImage.current
                  : `${process.env.REACT_APP_S3_ENDPOINT}/${product.image_url}`
              }
              alt={product.name}
              className="w-[100%] rounded-t-md  h-[50%] md:h-[60%] min-h-[200px] object-cover"
              onError={() => setIsBrokenImage((prev) => [product.id, ...prev])}
            />
            <div className="flex flex-col justify-evenly gap-y-5 py-4 w-[100%] h-[50%] md:h-[60%] px-5">
              <div className="flex flex-col gap-y-2 h-[70%] md:h-[60%]">
                <h3 className="product-name my-2 md:my-5">{product.name}</h3>
                <span className="product-description line-clamp-2 ">
                  {product.description}
                </span>
              </div>

              <a className="text-[14px] font-[500] font-Roboto text-slate-400 underline">
                Detalles
              </a>

              <div className="flex min-h-[40px]">
                <button
                  className="flex text-[16px] justify-center items-center h-[30px] font-Roboto font-[500] bg-mariposa p-4 rounded-xl text-white"
                  onClick={() => handleAdd(product)}
                >
                  <FaCartPlus className="mr-2" />
                  Agregar
                </button>
                <span className="product-price lining-nums">
                  ${product.price}
                </span>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ProductsByCategory;
